// Export an array of topics for VA 1st Grade Science
const sc5thScienceQuizContent = [
  {
    "slug": "motion",
    "title": "Motion",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is motion?",
        "answers": [
          { "text": "When something changes its place", "correct": true },
          { "text": "When something makes a sound", "correct": false },
          { "text": "When something gets bigger", "correct": false },
          { "text": "When something stays still", "correct": false }
        ]
      },
      {
        "question": "How do you know if something is in motion?",
        "answers": [
          { "text": "It keeps changing its position", "correct": true },
          { "text": "It makes a loud noise", "correct": false },
          { "text": "It shines like the sun", "correct": false },
          { "text": "It stays in one place", "correct": false }
        ]
      },
      {
        "question": "In the song, what example shows motion?",
        "answers": [
          { "text": "A car", "correct": true },
          { "text": "A tree", "correct": false },
          { "text": "A rock", "correct": false },
          { "text": "A chair", "correct": false }
        ]
      },
      {
        "question": "What happens if a parked car is moved 10 feet?",
        "answers": [
          { "text": "Motion has happened", "correct": true },
          { "text": "The car disappears", "correct": false },
          { "text": "The car changes color", "correct": false },
          { "text": "Nothing changes", "correct": false }
        ]
      },
      {
        "question": "If an object keeps moving without stopping, what is true?",
        "answers": [
          { "text": "It is in motion", "correct": true },
          { "text": "It is asleep", "correct": false },
          { "text": "It is eating", "correct": false },
          { "text": "It is staying still", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "instruments",
    "title": "Instruments",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#b2d8ff" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the instrument with its sound maker.",
        "options": [
          { "id": "guitar", "text": "Guitar", "targetText": "Vibrating strings" },
          { "id": "violin", "text": "Violin", "targetText": "Vibrating strings" },
          { "id": "flute", "text": "Flute", "targetText": "Vibrating air" },
          { "id": "trumpet", "text": "Trumpet", "targetText": "Vibrating air" },
          { "id": "drum", "text": "Drum", "targetText": "Vibrating head" }
        ]
      },
      {
        "question": "Match the sound with the instrument.",
        "options": [
          { "id": "string_sound", "text": "Twanging sound", "targetText": "Guitar or Violin" },
          { "id": "air_sound", "text": "Blowing air sound", "targetText": "Flute or Trumpet" },
          { "id": "beat_sound", "text": "Booming sound", "targetText": "Drum" },
          { "id": "singing_sound", "text": "Helps people sing", "targetText": "Guitar" }
        ]
      },
      {
        "question": "Match each instrument to the family it belongs to.",
        "options": [
          { "id": "strings", "text": "Strings", "targetText": "Guitar, Violin" },
          { "id": "winds", "text": "Winds", "targetText": "Flute, Trumpet" },
          { "id": "percussion", "text": "Percussion", "targetText": "Drum" },
          { "id": "voices", "text": "Voices", "targetText": "Singing" }
        ]
      },
      {
        "question": "Match the instrument to how you play it.",
        "options": [
          { "id": "pluck", "text": "Pluck strings", "targetText": "Guitar" },
          { "id": "bow", "text": "Use a bow", "targetText": "Violin" },
          { "id": "blow", "text": "Blow into", "targetText": "Flute, Trumpet" },
          { "id": "hit", "text": "Hit with sticks or hands", "targetText": "Drum" }
        ]
      },
      {
        "question": "Match the instrument to its picture or idea.",
        "options": [
          { "id": "guitar", "text": "Guitar", "targetText": "Has six strings" },
          { "id": "violin", "text": "Violin", "targetText": "Small, played with bow" },
          { "id": "flute", "text": "Flute", "targetText": "Long, silver tube" },
          { "id": "trumpet", "text": "Trumpet", "targetText": "Gold with valves" }
        ]
      }
    ]
  },
  {
    "slug": "soundvibration",
    "title": "Sound Vibration",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What makes sound?",
        "answers": [
          { "text": "Vibrations", "correct": true },
          { "text": "Colors", "correct": false },
          { "text": "Shadows", "correct": false },
          { "text": "Lights", "correct": false }
        ]
      },
      {
        "question": "What happens when you pluck a guitar string?",
        "answers": [
          { "text": "It vibrates and makes sound", "correct": true },
          { "text": "It grows longer", "correct": false },
          { "text": "It shines", "correct": false },
          { "text": "It stops moving", "correct": false }
        ]
      },
      {
        "question": "What part of your body vibrates to make sound?",
        "answers": [
          { "text": "Vocal cords", "correct": true },
          { "text": "Your eyes", "correct": false },
          { "text": "Your hair", "correct": false },
          { "text": "Your nose", "correct": false }
        ]
      },
      {
        "question": "Can you make sound soft or loud?",
        "answers": [
          { "text": "Yes, by changing vibrations", "correct": true },
          { "text": "No, sound is always the same", "correct": false },
          { "text": "Yes, by closing your eyes", "correct": false },
          { "text": "No, only machines make sound", "correct": false }
        ]
      },
      {
        "question": "In the song, what word is repeated many times?",
        "answers": [
          { "text": "Vibration", "correct": true },
          { "text": "Motion", "correct": false },
          { "text": "Season", "correct": false },
          { "text": "Plant", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "matter",
    "title": "Matter",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#ffe6b2" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the state of matter with its description.",
        "options": [
          { "id": "solid", "text": "Solid", "targetText": "Keeps its shape" },
          { "id": "liquid", "text": "Liquid", "targetText": "Takes the shape of its container" },
          { "id": "gas", "text": "Gas", "targetText": "Spreads out to fill space" }
        ]
      },
      {
        "question": "Match the state of matter to how its particles move.",
        "options": [
          { "id": "solid", "text": "Solid", "targetText": "Packed tightly, only vibrate" },
          { "id": "liquid", "text": "Liquid", "targetText": "Slide past each other" },
          { "id": "gas", "text": "Gas", "targetText": "Move quickly and spread out" }
        ]
      },
      {
        "question": "Match the object to its state of matter.",
        "options": [
          { "id": "ice", "text": "Ice", "targetText": "Solid" },
          { "id": "water", "text": "Water", "targetText": "Liquid" },
          { "id": "steam", "text": "Steam", "targetText": "Gas" }
        ]
      },
      {
        "question": "Match the state of matter to what happens if you pour it.",
        "options": [
          { "id": "solid", "text": "Solid", "targetText": "Does not pour" },
          { "id": "liquid", "text": "Liquid", "targetText": "Pours and takes shape of cup" },
          { "id": "gas", "text": "Gas", "targetText": "Spreads everywhere" }
        ]
      },
      {
        "question": "Match the state of matter with an example.",
        "options": [
          { "id": "solid", "text": "Solid", "targetText": "Rock" },
          { "id": "liquid", "text": "Liquid", "targetText": "Juice" },
          { "id": "gas", "text": "Gas", "targetText": "Air" }
        ]
      }
    ]
  },
  {
    "slug": "thingsplantsneed",
    "title": "Things Plants Need",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What do plants need to live?",
        "answers": [
          { "text": "Water, air, light, shelter, space", "correct": true },
          { "text": "Toys and clothes", "correct": false },
          { "text": "Computers and books", "correct": false },
          { "text": "Cars and bikes", "correct": false }
        ]
      },
      {
        "question": "Why do plants need sunlight?",
        "answers": [
          { "text": "It helps them grow", "correct": true },
          { "text": "It helps them run fast", "correct": false },
          { "text": "It makes them shiny", "correct": false },
          { "text": "It helps them sleep", "correct": false }
        ]
      },
      {
        "question": "What helps plants drink water?",
        "answers": [
          { "text": "Roots", "correct": true },
          { "text": "Leaves", "correct": false },
          { "text": "Flowers", "correct": false },
          { "text": "Fruit", "correct": false }
        ]
      },
      {
        "question": "What do plants breathe in?",
        "answers": [
          { "text": "Air", "correct": true },
          { "text": "Milk", "correct": false },
          { "text": "Juice", "correct": false },
          { "text": "Sand", "correct": false }
        ]
      },
      {
        "question": "What do plants need space for?",
        "answers": [
          { "text": "To grow tall and strong", "correct": true },
          { "text": "To play soccer", "correct": false },
          { "text": "To ride bikes", "correct": false },
          { "text": "To take naps", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "plantparts",
    "title": "Plant Parts",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#d4f5b2" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the plant part with its job.",
        "options": [
          { "id": "roots", "text": "Roots", "targetText": "Take in water and hold plant down" },
          { "id": "stem", "text": "Stem", "targetText": "Carries water to leaves" },
          { "id": "leaves", "text": "Leaves", "targetText": "Make food with sunlight" },
          { "id": "flowers", "text": "Flowers", "targetText": "Make seeds" }
        ]
      },
      {
        "question": "Match the plant part with what it makes.",
        "options": [
          { "id": "flower", "text": "Flower", "targetText": "Seeds" },
          { "id": "fruit", "text": "Fruit", "targetText": "Holds the seeds" },
          { "id": "seed", "text": "Seed", "targetText": "Baby plant (embryo)" }
        ]
      },
      {
        "question": "Match the plant part to its place on the plant.",
        "options": [
          { "id": "roots", "text": "Roots", "targetText": "Under the soil" },
          { "id": "stem", "text": "Stem", "targetText": "Middle of the plant" },
          { "id": "leaves", "text": "Leaves", "targetText": "Green and on the sides" },
          { "id": "flowers", "text": "Flowers", "targetText": "Bright colors at the top" }
        ]
      },
      {
        "question": "Match the part to what it needs most.",
        "options": [
          { "id": "roots", "text": "Roots", "targetText": "Soil and water" },
          { "id": "leaves", "text": "Leaves", "targetText": "Sunlight" },
          { "id": "stem", "text": "Stem", "targetText": "To carry food and water" },
          { "id": "seed", "text": "Seed", "targetText": "To grow into new plant" }
        ]
      },
      {
        "question": "Match the plant part to how it helps us.",
        "options": [
          { "id": "fruit", "text": "Fruit", "targetText": "Food we eat" },
          { "id": "leaves", "text": "Leaves", "targetText": "Make oxygen to breathe" },
          { "id": "stem", "text": "Stem", "targetText": "Some are food (celery)" },
          { "id": "flowers", "text": "Flowers", "targetText": "Look pretty and smell nice" }
        ]
      }
    ]
  },
  {
    "slug": "whatdoplantsneed",
    "title": "What Do Plants Need",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What do plants breathe in to live?",
        "answers": [
          { "text": "Air", "correct": true },
          { "text": "Candy", "correct": false },
          { "text": "Juice", "correct": false },
          { "text": "Cheese", "correct": false }
        ]
      },
      {
        "question": "Plants need water and what else from the soil?",
        "answers": [
          { "text": "Nutrients", "correct": true },
          { "text": "Sugar", "correct": false },
          { "text": "Plastic", "correct": false },
          { "text": "Gold", "correct": false }
        ]
      },
      {
        "question": "Plants can live in what two places?",
        "answers": [
          { "text": "On land or in water", "correct": true },
          { "text": "In the sky and clouds", "correct": false },
          { "text": "On the moon", "correct": false },
          { "text": "In houses only", "correct": false }
        ]
      },
      {
        "question": "What do plants give to animals and people?",
        "answers": [
          { "text": "Food", "correct": true },
          { "text": "Cars", "correct": false },
          { "text": "Shoes", "correct": false },
          { "text": "Houses", "correct": false }
        ]
      },
      {
        "question": "What do plants need from the sun?",
        "answers": [
          { "text": "Light", "correct": true },
          { "text": "Music", "correct": false },
          { "text": "Ice", "correct": false },
          { "text": "Toys", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "plantsandanimalsneedtheirspace",
    "title": "Plants and Animals Need Their Space",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#f2e6ff" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the need with plant or animal.",
        "options": [
          { "id": "plants_sunlight", "text": "Plants need sunlight", "targetText": "To grow" },
          { "id": "plants_bees", "text": "Plants need bees", "targetText": "To spread seeds" },
          { "id": "animals_water", "text": "Animals need water", "targetText": "To drink" },
          { "id": "animals_shelter", "text": "Animals need shelter", "targetText": "To stay safe" }
        ]
      },
      {
        "question": "Match the space with who needs it.",
        "options": [
          { "id": "plants", "text": "Plants", "targetText": "Space to grow" },
          { "id": "animals", "text": "Animals", "targetText": "Space to live and move" }
        ]
      },
      {
        "question": "Match the home with the animal.",
        "options": [
          { "id": "bees", "text": "Bees", "targetText": "Hive" },
          { "id": "ants", "text": "Ants", "targetText": "Ant farm" },
          { "id": "fish", "text": "Fish", "targetText": "Water" },
          { "id": "birds", "text": "Birds", "targetText": "Nest" }
        ]
      },
      {
        "question": "Match the change to what it affects.",
        "options": [
          { "id": "too_hot", "text": "Too hot", "targetText": "Plants dry out" },
          { "id": "no_water", "text": "No water", "targetText": "Animals thirsty" },
          { "id": "no_space", "text": "No space", "targetText": "Plants can’t grow" }
        ]
      },
      {
        "question": "Match the word to the meaning.",
        "options": [
          { "id": "ecosystem", "text": "Ecosystem", "targetText": "Home for plants and animals" },
          { "id": "shelter", "text": "Shelter", "targetText": "Safe place to live" },
          { "id": "sunlight", "text": "Sunlight", "targetText": "Energy from the sun" }
        ]
      }
    ]
  },
  {
    "slug": "animalneeds",
    "title": "Animal Needs",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What do all animals need to live?",
        "answers": [
          { "text": "Food, water, and shelter", "correct": true },
          { "text": "Clothes and toys", "correct": false },
          { "text": "Cars and houses", "correct": false },
          { "text": "Books and pencils", "correct": false }
        ]
      },
      {
        "question": "Why do animals need food?",
        "answers": [
          { "text": "To stay alive and healthy", "correct": true },
          { "text": "To play games", "correct": false },
          { "text": "To glow in the dark", "correct": false },
          { "text": "To fly in space", "correct": false }
        ]
      },
      {
        "question": "What do animals drink to live?",
        "answers": [
          { "text": "Water", "correct": true },
          { "text": "Juice", "correct": false },
          { "text": "Soda", "correct": false },
          { "text": "Milkshakes", "correct": false }
        ]
      },
      {
        "question": "What keeps animals safe?",
        "answers": [
          { "text": "Shelter", "correct": true },
          { "text": "Television", "correct": false },
          { "text": "Rainbows", "correct": false },
          { "text": "Shoes", "correct": false }
        ]
      },
      {
        "question": "What do some animals need like plants?",
        "answers": [
          { "text": "Sunlight", "correct": true },
          { "text": "Computers", "correct": false },
          { "text": "Tables", "correct": false },
          { "text": "Hats", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "habitats",
    "title": "Habitats",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#c2f0f7" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the animal with its habitat.",
        "options": [
          { "id": "ants", "text": "Ants", "targetText": "Ant farm" },
          { "id": "bees", "text": "Bees", "targetText": "Hive" },
          { "id": "fish", "text": "Fish", "targetText": "Water" },
          { "id": "toucan", "text": "Toucan", "targetText": "Rainforest" }
        ]
      },
      {
        "question": "Match the habitat with what it gives.",
        "options": [
          { "id": "food", "text": "Food", "targetText": "Helps animals eat" },
          { "id": "water", "text": "Water", "targetText": "Helps animals drink" },
          { "id": "shelter", "text": "Shelter", "targetText": "Keeps animals safe" },
          { "id": "air", "text": "Air", "targetText": "Helps animals breathe" }
        ]
      },
      {
        "question": "Match the habitat with the right temperature.",
        "options": [
          { "id": "desert", "text": "Desert", "targetText": "Hot and dry" },
          { "id": "arctic", "text": "Arctic", "targetText": "Cold and icy" },
          { "id": "forest", "text": "Forest", "targetText": "Cool and shady" },
          { "id": "rainforest", "text": "Rainforest", "targetText": "Warm and wet" }
        ]
      },
      {
        "question": "Match the word with its meaning.",
        "options": [
          { "id": "habitat", "text": "Habitat", "targetText": "Home of an animal" },
          { "id": "population", "text": "Population", "targetText": "Group of same animals" },
          { "id": "organisms", "text": "Organisms", "targetText": "Living things" }
        ]
      },
      {
        "question": "Match the animal with what it needs most.",
        "options": [
          { "id": "fish", "text": "Fish", "targetText": "Clean water" },
          { "id": "birds", "text": "Birds", "targetText": "Trees for nests" },
          { "id": "bees", "text": "Bees", "targetText": "Flowers for food" }
        ]
      }
    ]
  },
  {
    "slug": "fromthesun",
    "title": "From the Sun",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What does the sun give the Earth?",
        "answers": [
          { "text": "Energy", "correct": true },
          { "text": "Toys", "correct": false },
          { "text": "Cars", "correct": false },
          { "text": "Clothes", "correct": false }
        ]
      },
      {
        "question": "What happens when the sun heats water?",
        "answers": [
          { "text": "It turns into gas (evaporation)", "correct": true },
          { "text": "It turns into ice", "correct": false },
          { "text": "It makes food", "correct": false },
          { "text": "It glows in the dark", "correct": false }
        ]
      },
      {
        "question": "What do clouds form from?",
        "answers": [
          { "text": "Water vapor", "correct": true },
          { "text": "Sand", "correct": false },
          { "text": "Rocks", "correct": false },
          { "text": "Metal", "correct": false }
        ]
      },
      {
        "question": "What comes down from clouds?",
        "answers": [
          { "text": "Rain, snow, or hail", "correct": true },
          { "text": "Shoes", "correct": false },
          { "text": "Candy", "correct": false },
          { "text": "Fireworks", "correct": false }
        ]
      },
      {
        "question": "What makes the water cycle go?",
        "answers": [
          { "text": "The sun’s energy", "correct": true },
          { "text": "Cars", "correct": false },
          { "text": "Computers", "correct": false },
          { "text": "Windmills", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "thesunbringslight",
    "title": "The Sun Brings Light",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#fff2cc" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match what the sun gives with its effect.",
        "options": [
          { "id": "light", "text": "Light", "targetText": "Helps plants grow" },
          { "id": "heat", "text": "Heat", "targetText": "Keeps Earth warm" },
          { "id": "energy", "text": "Energy", "targetText": "Powers life on Earth" }
        ]
      },
      {
        "question": "Match the word with what it does.",
        "options": [
          { "id": "reflect", "text": "Reflect", "targetText": "Bounces back into space" },
          { "id": "absorb", "text": "Absorb", "targetText": "Taken in by Earth" }
        ]
      },
      {
        "question": "Match the sun effect with what we see.",
        "options": [
          { "id": "plants", "text": "Plants grow tall", "targetText": "Sun gives light" },
          { "id": "oceans", "text": "Oceans glow", "targetText": "Sun gives heat" }
        ]
      },
      {
        "question": "Match the thing with how it feels from the sun.",
        "options": [
          { "id": "land", "text": "Land", "targetText": "Gets warm" },
          { "id": "water", "text": "Water", "targetText": "Heats and cools slowly" },
          { "id": "air", "text": "Air", "targetText": "Feels hot or cold" }
        ]
      },
      {
        "question": "Match the sun fact with the right word.",
        "options": [
          { "id": "star", "text": "Star", "targetText": "The sun is one" },
          { "id": "life", "text": "Life", "targetText": "Needs the sun" },
          { "id": "patterns", "text": "Patterns", "targetText": "Warmth helps life begin" }
        ]
      }
    ]
  },
  {
    "slug": "nightandday",
    "title": "Night & Day",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Why do we have night and day?",
        "answers": [
          { "text": "Because Earth spins", "correct": true },
          { "text": "Because the sun goes away", "correct": false },
          { "text": "Because the moon eats the sun", "correct": false },
          { "text": "Because stars turn on and off", "correct": false }
        ]
      },
      {
        "question": "How long does it take Earth to spin once?",
        "answers": [
          { "text": "24 hours (1 day)", "correct": true },
          { "text": "1 hour", "correct": false },
          { "text": "1 week", "correct": false },
          { "text": "1 year", "correct": false }
        ]
      },
      {
        "question": "What side of Earth has day?",
        "answers": [
          { "text": "The side facing the sun", "correct": true },
          { "text": "The side facing the moon", "correct": false },
          { "text": "The side facing stars", "correct": false },
          { "text": "The side facing space", "correct": false }
        ]
      },
      {
        "question": "What side of Earth has night?",
        "answers": [
          { "text": "The side turned away from the sun", "correct": true },
          { "text": "The side with clouds", "correct": false },
          { "text": "The side with animals", "correct": false },
          { "text": "The side with plants", "correct": false }
        ]
      },
      {
        "question": "What makes the sun seem to move in the sky?",
        "answers": [
          { "text": "The Earth spins", "correct": true },
          { "text": "The sun moves around Earth", "correct": false },
          { "text": "The moon pushes it", "correct": false },
          { "text": "Clouds carry it", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "weatherpatterns",
    "title": "Weather Patterns",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#e8f4ff" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the weather word to what it means.",
        "options": [
          { "id": "temperature", "text": "Temperature", "targetText": "How hot or cold it is" },
          { "id": "wind", "text": "Wind", "targetText": "Air that moves" },
          { "id": "clouds", "text": "Clouds", "targetText": "Water drops in the sky" }
        ]
      },
      {
        "question": "Match the kind of weather to a picture idea.",
        "options": [
          { "id": "sunny", "text": "Sunny", "targetText": "Bright sun, few clouds" },
          { "id": "rainy", "text": "Rainy", "targetText": "Raindrops falling" },
          { "id": "snowy", "text": "Snowy", "targetText": "White flakes falling" },
          { "id": "windy", "text": "Windy", "targetText": "Leaves blowing" }
        ]
      },
      {
        "question": "Match the season to the kind of weather we often see.",
        "options": [
          { "id": "spring", "text": "Spring", "targetText": "Rain and flowers" },
          { "id": "summer", "text": "Summer", "targetText": "Hot and sunny" },
          { "id": "fall", "text": "Fall (Autumn)", "targetText": "Cooler, leaves change" },
          { "id": "winter", "text": "Winter", "targetText": "Cold, sometimes snow" }
        ]
      },
      {
        "question": "Match the sky sound or sight to its name.",
        "options": [
          { "id": "thunder", "text": "Thunder", "targetText": "Loud rumble" },
          { "id": "lightning", "text": "Lightning", "targetText": "Bright flash" },
          { "id": "breeze", "text": "Breeze", "targetText": "Soft wind" }
        ]
      },
      {
        "question": "Match the clothing to the weather.",
        "options": [
          { "id": "raincoat", "text": "Raincoat", "targetText": "Rainy" },
          { "id": "shorts", "text": "Shorts", "targetText": "Hot day" },
          { "id": "coat", "text": "Winter coat", "targetText": "Cold day" },
          { "id": "hat", "text": "Sun hat", "targetText": "Sunny day" }
        ]
      }
    ]
  },
  {
    "slug": "precipitation",
    "title": "Precipitation",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is precipitation?",
        "answers": [
          { "text": "Rain, sleet, snow, or hail", "correct": true },
          { "text": "Sunshine and clouds", "correct": false },
          { "text": "Wind and air", "correct": false },
          { "text": "Fog only", "correct": false }
        ]
      },
      {
        "question": "What is rain?",
        "answers": [
          { "text": "Water drops falling from the sky", "correct": true },
          { "text": "Tiny rocks", "correct": false },
          { "text": "Sunshine", "correct": false },
          { "text": "Cloud pieces", "correct": false }
        ]
      },
      {
        "question": "What is snow?",
        "answers": [
          { "text": "Soft white ice crystals", "correct": true },
          { "text": "Falling leaves", "correct": false },
          { "text": "Hot steam", "correct": false },
          { "text": "Big water drops", "correct": false }
        ]
      },
      {
        "question": "What is sleet?",
        "answers": [
          { "text": "Small ice pellets", "correct": true },
          { "text": "Windy air", "correct": false },
          { "text": "Warm rain", "correct": false },
          { "text": "Bright light", "correct": false }
        ]
      },
      {
        "question": "What is hail?",
        "answers": [
          { "text": "Large ice balls from clouds", "correct": true },
          { "text": "Tiny water mist", "correct": false },
          { "text": "Falling sand", "correct": false },
          { "text": "Raindrops only at night", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "seasons",
    "title": "Seasons",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#fff0f5" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the season to the month feeling.",
        "options": [
          { "id": "spring", "text": "Spring", "targetText": "Warmer, plants grow" },
          { "id": "summer", "text": "Summer", "targetText": "Hottest days" },
          { "id": "fall", "text": "Fall (Autumn)", "targetText": "Cooler, leaves fall" },
          { "id": "winter", "text": "Winter", "targetText": "Coldest days" }
        ]
      },
      {
        "question": "Match the activity to the best season.",
        "options": [
          { "id": "snowman", "text": "Build a snowman", "targetText": "Winter" },
          { "id": "swim", "text": "Go swimming", "targetText": "Summer" },
          { "id": "leafpile", "text": "Jump in leaf piles", "targetText": "Fall" },
          { "id": "plant", "text": "Plant seeds", "targetText": "Spring" }
        ]
      },
      {
        "question": "Match the season to what we wear.",
        "options": [
          { "id": "coat", "text": "Big coat", "targetText": "Winter" },
          { "id": "tshirt", "text": "T-shirt and shorts", "targetText": "Summer" },
          { "id": "rainboots", "text": "Rain boots", "targetText": "Spring" },
          { "id": "sweater", "text": "Sweater", "targetText": "Fall" }
        ]
      },
      {
        "question": "Match the word to the idea.",
        "options": [
          { "id": "tilt", "text": "Tilt of Earth", "targetText": "Helps make seasons" },
          { "id": "daylength", "text": "Day length", "targetText": "More sun in summer" }
        ]
      },
      {
        "question": "Match the picture idea to the season.",
        "options": [
          { "id": "flowers", "text": "Flowers blooming", "targetText": "Spring" },
          { "id": "beach", "text": "Beach and sun", "targetText": "Summer" },
          { "id": "leaves", "text": "Orange leaves", "targetText": "Fall" },
          { "id": "snow", "text": "Snowflakes", "targetText": "Winter" }
        ]
      }
    ]
  },
  {
    "slug": "naturalresources",
    "title": "Natural Resources",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What are natural resources?",
        "answers": [
          { "text": "Things from nature people use", "correct": true },
          { "text": "Toys from a store", "correct": false },
          { "text": "TV shows", "correct": false },
          { "text": "Computer games", "correct": false }
        ]
      },
      {
        "question": "Which is a renewable resource?",
        "answers": [
          { "text": "Trees", "correct": true },
          { "text": "Coal that takes millions of years", "correct": false },
          { "text": "Gas from deep underground", "correct": false },
          { "text": "Oil only", "correct": false }
        ]
      },
      {
        "question": "Which is a nonrenewable resource?",
        "answers": [
          { "text": "Coal", "correct": true },
          { "text": "Fresh apples every year", "correct": false },
          { "text": "Fish that have babies", "correct": false },
          { "text": "Grass that grows back", "correct": false }
        ]
      },
      {
        "question": "Which is an inexhaustible resource (won’t run out in our lives)?",
        "answers": [
          { "text": "Sunlight", "correct": true },
          { "text": "Chocolate", "correct": false },
          { "text": "Plastic toys", "correct": false },
          { "text": "Pencils", "correct": false }
        ]
      },
      {
        "question": "Which can be recycled and used again?",
        "answers": [
          { "text": "Aluminum cans", "correct": true },
          { "text": "Banana peels", "correct": false },
          { "text": "Sunshine", "correct": false },
          { "text": "Rain clouds", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "pollution",
    "title": "Pollution",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#ffe6e6" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the kind of pollution to a cause.",
        "options": [
          { "id": "air", "text": "Air pollution", "targetText": "Car exhaust, burning fuel" },
          { "id": "water", "text": "Water pollution", "targetText": "Poison/oil in water" },
          { "id": "soil", "text": "Soil pollution", "targetText": "Weed and bug killers" }
        ]
      },
      {
        "question": "Match the action to help the planet.",
        "options": [
          { "id": "trash_can", "text": "Use a trash can", "targetText": "Keeps ground clean" },
          { "id": "no_litter", "text": "Do not litter", "targetText": "Protects animals" },
          { "id": "plant_tree", "text": "Plant a tree", "targetText": "Helps air be clean" }
        ]
      },
      {
        "question": "Match the problem to what it hurts.",
        "options": [
          { "id": "dirty_air", "text": "Dirty air", "targetText": "Hard to breathe" },
          { "id": "dirty_water", "text": "Dirty water", "targetText": "Fish get sick" },
          { "id": "dirty_soil", "text": "Dirty soil", "targetText": "Plants can’t grow well" }
        ]
      },
      {
        "question": "Match the word to the meaning.",
        "options": [
          { "id": "contaminants", "text": "Contaminants", "targetText": "Harmful things" },
          { "id": "environment", "text": "Environment", "targetText": "Our air, water, and land" }
        ]
      },
      {
        "question": "Match the better choice.",
        "options": [
          { "id": "walk", "text": "Walk or bike", "targetText": "Less air pollution" },
          { "id": "pick_up", "text": "Pick up litter", "targetText": "Cleaner parks" },
          { "id": "stop_pouring", "text": "Don’t pour oil outside", "targetText": "Protects water" }
        ]
      }
    ]
  },
  {
    "slug": "reducereuseandrecycle",
    "title": "Reduce, Reuse, and Recycle",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What does “reduce” mean?",
        "answers": [
          { "text": "Use less so we make less trash", "correct": true },
          { "text": "Throw more away", "correct": false },
          { "text": "Make bigger bags", "correct": false },
          { "text": "Break things", "correct": false }
        ]
      },
      {
        "question": "What does “reuse” mean?",
        "answers": [
          { "text": "Use something again", "correct": true },
          { "text": "Throw it away right away", "correct": false },
          { "text": "Hide it in a drawer", "correct": false },
          { "text": "Buy a new one every time", "correct": false }
        ]
      },
      {
        "question": "What does “recycle” mean?",
        "answers": [
          { "text": "Turn old things into new things", "correct": true },
          { "text": "Put trash on the ground", "correct": false },
          { "text": "Burn everything", "correct": false },
          { "text": "Keep it forever", "correct": false }
        ]
      },
      {
        "question": "Which is a good way to reduce?",
        "answers": [
          { "text": "Say no to extra store bags", "correct": true },
          { "text": "Use five cups for one drink", "correct": false },
          { "text": "Take more napkins than you need", "correct": false },
          { "text": "Leave lights on all day", "correct": false }
        ]
      },
      {
        "question": "Which can you recycle?",
        "answers": [
          { "text": "Paper and many plastics", "correct": true },
          { "text": "Leftover soup", "correct": false },
          { "text": "Banana peels", "correct": false },
          { "text": "Sand", "correct": false }
        ]
      }
    ]
  }
]

export default sc5thScienceQuizContent;
